import { pushGaEvent, pushGtagEvent } from '@v4/common/utils/google-analytics';

const gaEventHandler = {
    methods: {
        pushGaEvent,
        pushGtagEvent,
        /**
         * Pushes a ga event with a debouncing time
         *
         * @param {array} args first 2 arguments are mandatory
         * @param {number=} debounceTime
         *
         * @returns {void}
         */
        pushDebounceGaEvent(args = [], debounceTime = 0) {
            if (debounceTime > 0 && args.length >= 2) {
                this._timer = setTimeout(() => {
                    this.pushGaEvent(...args);
                }, debounceTime);
            }
        },
    },
    destroyed() {
        if (this._timer > 0) {
            clearTimeout(this._timer);
        }
    },
};

export default gaEventHandler;
